import { render } from "./createProject.vue?vue&type=template&id=653b3514&scoped=true"
import script from "./createProject.js?vue&type=script&lang=js"
export * from "./createProject.js?vue&type=script&lang=js"

import "./createProject.vue?vue&type=style&index=0&id=653b3514&scoped=true&lang=css"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-653b3514"]])

export default __exports__